import moment from "moment";
import "moment-timezone"

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export const parseTime = (timestr) => {
  let t = timestr.split(":");
  if (!t[0] || !t[1]) return false;
  t[0] = t[0].trim();
  t[1] = t[1].trim()

  let hours = Number(t[0]);
  let minutes = Number(t[1].substr(0, 2));
  let AmPm = t[1].substr(2);
  if (isNaN(hours) || isNaN(minutes) || (AmPm !== 'AM' && AmPm !== 'PM')) return false;

  if (AmPm === 'PM') hours = hours + 12;
  return {
    hours,
    minutes
  }
}


export const getTodayDate = (timezoneString) => {
  let startAt = moment().tz(timezoneString);
  startAt.set({
    date: startAt.date() + 1,
    hour: 9,
    minute: 0,
    second: 0,
  })
  let endAt = moment().tz(timezoneString);
  endAt.set({
    date: endAt.date() + 1,
    hour: 10,
    minute: 0,
    second: 0,
  })
  // startAt = moment.tz(startAt, timezone)
  // endAt = moment.tz(endAt, timezone)
  return {
    startAt,
    endAt
  }
}

//SEP 09 2021. 10: 46PM - 11: 44PM

export const parseDateTime = (str) => {

  if (!str) return false
  let date = str.split('.')[0];
  if (!date) return false
  date = date.split(' ');
  if (date.length !== 3) return false
  let month = months.indexOf(date[0]);
  let day = Number(date[1]);
  let year = Number(date[2]);

  if (month < 0 || isNaN(day) || isNaN(year) || date[2].length !== 4) return false
  let time = str.split('.')[1];
  if (!time) return false
  time = time.trim().split("-");
  let startTime = time[0];
  let endTime = time[1];
  if (!startTime || !endTime) return false
  startTime = parseTime(startTime);
  endTime = parseTime(endTime);
  if (!startTime || !endTime) return false
  let startDateTime = new Date(year, month, day, startTime.hours, startTime.minutes);
  let endDateTime = new Date(year, month, day, endTime.hours, endTime.minutes);
  if (startDateTime.getTime() > endDateTime.getTime()) return false
  let res = {
    startAt: startDateTime.toISOString(),
    endAt: endDateTime.toISOString()
  }
  return res
}

export const formatTime = (date) => {
  let h = date.getHours();
  let m = date.getMinutes();
  let amPm = "AM";
  if (h > 12) {
    h = h - 12;
    amPm = "PM";
  }
  if (h == 0) {
    h = 12;
  }
  if (h == 12) {
    amPm = "PM";
  }
  if (m < 10) m = "0" + m
  return h + ":" + m + amPm
}

export const parseDate = (d) => {
  const date = new Date(d);
  let month = date.getMonth() + 1;
  let day = date.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  return month + "/" + day + "/" + date.getFullYear() + ", " + formatTime(date);
}

export const parseDateToPropertyTimezone = (event, timezoneString) => {
  let eventsDate = {};

  if (event.startAt && event.endAt) {
    // eventsDate.startAt = moment.tz(event.startAt, timezone);
    // eventsDate.endAt = moment.tz(event.endAt, timezone)

    eventsDate.startAt = moment(event.startAt).tz(timezoneString);
    eventsDate.endAt = moment(event.endAt).tz(timezoneString);
  }
  if (event.publishAt) {
    // eventsDate.publishAt = moment.tz(event.publishAt, timezone)
    eventsDate.publishAt = moment(event.publishAt).tz(timezoneString);
  }
  if (event.inviteScheduledAt) {
    // eventsDate.inviteScheduledAt = moment.tz(event.inviteScheduledAt, timezone)
    eventsDate.inviteScheduledAt = moment(event.inviteScheduledAt).tz(timezoneString);
  }
  if (event.recurrenceEndDate) {
    eventsDate.recurrenceEndDate = moment(event.recurrenceEndDate).tz(timezoneString);
  }
  // } else {
  //   let currentDate = new moment().tz(timezoneString);
  //   currentDate.add(1, 'M')
  //   eventsDate.recurrenceEndDate = currentDate;
  // }
  return eventsDate
}


export const getDisplayTime = (startAt, endAt) => {
  const startTime = startAt.format("ddd, MMM DD, hh:mm a");
  const endTime = endAt.format("hh:mm a");
  let datStr = startTime + " - " + endTime;
  return datStr
}


export const parseDateTimeToString = (startAt, endAt, timezoneString) => {
  let start = moment(startAt).tz(timezoneString);
  let end = moment(endAt).tz(timezoneString);
  // let start = moment.tz(startAt, timezone)
  // let end = moment.tz(endAt, timezone)
  const month = start.format("MMM");
  const date = start.format("DD");
  const year = start.format("YYYY");
  const startTime = start.format("hh:mmA");
  const endTime = end.format("hh:mmA");
  let datStr = month + " " + date + " " + year + ", " + startTime + " - " + endTime;
  return { dateTime: datStr }
}

export const parseDateToString = (startAt, timezoneString) => {
  let start = moment(startAt).tz(timezoneString);
  const startTime = start.format("MMM DD, YYYY - hh:mm a");
  return startTime
}

export const socialMediaShareDate = (startAt, timezoneString) => {
  let start = moment(startAt).tz(timezoneString);
  const month = start.format("MMM");
  const day = start.format('dddd')
  const date = start.format("DD");
  const year = start.format("YYYY");
  const startTime = start.format("hh:mmA");
  return day + ", " + date + " " + month + ", " + year + ", starting at " + startTime
}

export const getMinValidDate = (timezoneString, userIsApprover) => {
  let extraMin = userIsApprover ? 1 : 15;
  let now = moment(new Date().toISOString()).tz(timezoneString);
  now.minute(now.minute() + extraMin);
  return now;
};